import FJAppConstant from '../constants/FJAppConstant.js';
import CryptoJS from 'crypto-js';
import FJUtil from './FJUtil.js';
import FJConfig from '../config/FJConfig.js';
import FJNetworkStore from '../store/FJNetworkStore.js';
import FJCommunityConfig from '../config/appConfig/FJCommunityConfig.js';
import FJLocalStore from '../store/FJLocalStore.js';
import FJConstant from '../constants/FJConstant.js';
const useKeyMap = new Map();
const COMMUNITY_BEHAVIOR_TYPE = {
    1: 'preview',
    2: 'like',
    3: 'share',
    4: 'recreate',
    5: 'download',
};
const FJCommunityUtil = {
    _userKey: '',
    isUseNewPreviewModal: function (appType) {
        const toolsList = [
            FJAppConstant.TEXT_TO_IMAGE,
            FJAppConstant.IMAGE_TO_IMAGE,
            FJAppConstant.AI_PHOTO_EDITOR,
            FJAppConstant.AI_VIDEO_GENERATOR,
        ];
        if (toolsList.includes(appType)) {
            return true;
        }
        return false;
    },
    isSupportCommunityAppType: function (appType) {
        return this.isUseNewPreviewModal(appType);
    },
    getUserKey: function () {
        const uid = FJUtil.getUserId().toString();
        if (useKeyMap.has(uid)) {
            return useKeyMap.get(uid);
        }
        const userKey = uid ? uid + CryptoJS.MD5(uid).toString() : '';
        useKeyMap.set(uid, userKey);
        return userKey;
    },
    openUserPage: function (userKey) {
        window.open(`${FJUtil.getCurrentUrl()}${FJConfig.isRelease ? 'ai' : 'apply'}/home/${userKey}`, '_blank');
    },

    addCommunityBehavior: async function (communityIds, behaviorTypeNum) {
        const behaviorType = COMMUNITY_BEHAVIOR_TYPE[behaviorTypeNum] || '';
        if (!behaviorType || !communityIds || communityIds.length === 0 || !FJUtil.isLogin()) {
            return false;
        }
        try {
            const data = await FJNetworkStore.addCommunityBehavior({ communityIds, behaviorType });
            if (data) {
                return true;
            }
            return false;
        } catch (error) {
            console.log(error);
            return false;
        }
    },
    setLocalStoragePrivacyStatus: privacyStatus => {
        localStorage.setItem('privacyStatus', privacyStatus);
    },
    getLocalStoragePrivacyStatus: () => {
        return localStorage.getItem('privacyStatus');
    },

    /**
     * @description 返回radio type
     * @param {number} ratio
     * @param {boolean} shouldPortraitReplaceVerticel - 是否使用 portrait 替换 vertical
     * @returns {string}
     */
    getRatioType: function (ratio, shouldPortraitReplaceVerticel) {
        let ratioType = '';
        if (Math.abs(ratio - 1.78) < 0.02) {
            ratioType = 'landscape';
        } else if (Math.abs(ratio - 0.56) < 0.02) {
            if (shouldPortraitReplaceVerticel) {
                ratioType = 'portrait';
            } else {
                ratioType = 'vertical';
            }
        } else if (Math.abs(ratio - 1) < 0.02) {
            ratioType = 'square';
        } else if (Math.abs(ratio - 2.33) < 0.02) {
            ratioType = 'cinematic';
        } else if (Math.abs(ratio - 0.8) < 0.02) {
            ratioType = 'social';
        } else {
            ratioType = 'landscape';
        }
        return ratioType;
    },

    /**
     * @description 返回封面图预览地址
     * @param {string} keyName
     * @param {number} ratio
     * @param ratioLists
     * @param {object} options
     * @param {string} options.suffix
     * @returns {string|`${string}w400/${string}.jpg`}
     */
    getTemplatePreviewCoverPath: function (keyName, ratio, ratioLists = [], options) {
        const { viceTemplateImagePath } = FJCommunityConfig;
        const ratioItem = ratioLists.find(item => Math.abs(ratio - item.ratio) < 0.02);
        if (!keyName) {
            return '';
        }
        let imageUrl = '';
        const suffix = options?.suffix || 'jpg';
        if (
            ratioItem &&
            typeof ratioItem.isMainTemplate !== 'undefined' &&
            ratioItem.isMainTemplate.toString() === '0'
        ) {
            const language = ratioItem.lang;
            const ratioType = this.getRatioType(ratioItem.ratio, true);
            imageUrl = `${viceTemplateImagePath}${ratioType}/${language}/w400/${keyName}.${suffix}`;
        } else {
            imageUrl = `${viceTemplateImagePath}w400/${keyName}.${suffix}`;
        }
        return imageUrl;
    },
    /**
     * @description 返回封面图预览地址
     * @param {string} keyName
     * @param {number} ratio
     * @param ratioLists
     * @param {object} options
     * @param {string} options.suffix
     * @returns {string|`${string}w400/${string}.jpg`}
     */
    getRealTemplatePreviewCoverPath: function (keyName, ratio, ratioLists = [], options) {
        const { viceTemplateImagePath } = FJConfig;
        const ratioItem = ratioLists.find(item => Math.abs(ratio - item.ratio) < 0.02);
        if (!keyName) {
            return '';
        }
        let imageUrl = '';
        const suffix = options?.suffix || 'jpg';
        if (ratioItem) {
            if (typeof ratioItem.isMainTemplate !== 'undefined' && ratioItem.isMainTemplate.toString() === '0') {
                const language = ratioItem.lang;
                const ratioType = this.getRatioType(ratioItem.ratio, true);
                imageUrl = `${viceTemplateImagePath}${ratioType}/${language}/w400/${keyName}.${suffix}`;
            } else {
                imageUrl = `${viceTemplateImagePath}w400/${keyName}.${suffix}`;
            }
        }

        return imageUrl;
    },

    getTemplatePreviewCoverListPath: function (keyName, ratio, ratioLists = []) {
        const { viceTemplateBoardImagePath } = FJCommunityConfig;
        const ratioItem = ratioLists.find(item => Math.abs(ratio - item.ratio) < 0.02);
        if (!keyName) {
            return '';
        }

        const suffix = 'jpg';
        if (ratioItem) {
            const language = ratioItem.lang;
            const boardDurationList = ratioItem.actual_duration;
            const ratioType = this.getRatioType(ratioItem.ratio, true);
            return ratioItem.boards.map((item, index) => {
                const url =
                    ratioItem.isMainTemplate.toString() === '0'
                        ? `${viceTemplateBoardImagePath}${ratioType}/${language}/${keyName}/${item}.${suffix}`
                        : `${viceTemplateBoardImagePath}${keyName}/${item}.${suffix}`;
                return {
                    url,
                    duration: boardDurationList[index],
                };
            });
        }
    },

    /**
     * @description 返回预览video地址
     * @param keyName
     * @param ratio
     * @param ratioLists
     * @param videoSizeType
     * @returns {string|`${string}${string}/${string}.mp4`}
     */
    getTemplatePreviewVideoPath: function (keyName, ratio, ratioLists = [], videoSizeType) {
        const { viceTemplateVideoPath } = FJCommunityConfig;
        const ratioItem = ratioLists.find(item => Math.abs(ratio - item.ratio) < 0.02);
        if (!keyName) {
            return '';
        }
        const videoSize = videoSizeType === 'LOW' ? '226p' : '720p';
        let videoUrl = '';
        if (ratioItem && ratioItem.isMainTemplate === '0') {
            const language = ratioItem.lang;
            const ratioType = this.getRatioType(ratioItem.ratio, true);
            videoUrl = `${viceTemplateVideoPath}${ratioType}/${language}/${videoSize}/${keyName}.mp4`;
        } else {
            videoUrl = `${viceTemplateVideoPath}${videoSize}/${keyName}.mp4`;
        }
        return videoUrl;
    },

    getTemplateDataByRatio: function (data, ratio) {
        if (!ratio) {
            return { ...data };
        }
        const { ratioLists = [] } = data;
        const ratioItem = ratioLists.find(item => Math.abs(ratio - item.ratio) < 0.02);
        if (ratioItem) {
            return {
                ...data,
                ratio: ratioItem.ratio,
            };
        } else {
            return { ...data };
        }
    },
    onTemplateRecreate: function (info) {
        const { id: templateId, ratio: templateRatio } = info;
        const ratio = this.getRatioType(templateRatio);
        try {
            let lang = FJLocalStore.currentTag();
            let url;
            const targetLanguage = lang !== 'en' ? `/${lang}` : '';
            url = `${targetLanguage}/editor/app?template_id=${templateId}&ratio=${ratio}&is_template_edit=true`;
            window.open(url, '_blank');
        } catch (e) {
            console.log(e);
        }
    },
    getCommunityPageName: function ({ appType, communityNavBarTab, workType }) {
        if (workType === FJConstant.COMMUNITY_WORK) {
            return 'ai community';
        } else if (workType === FJConstant.HOME_WORK) {
            return 'ai home';
        } else if (appType === FJAppConstant.AI_COMMUNITY) {
            if (communityNavBarTab === FJConstant.HOME) {
                return 'ai home';
            } else if (communityNavBarTab === FJConstant.COMMUNITY) {
                return 'ai community';
            }
        } else return FJUtil.getToolName(appType);
        return '';
    },
    onPreviewJumpToApp: async function (info, options) {
        const { currentAppType, targetAppType, href } = options;
        const recId = `${Date.now()}${Math.random().toString(36).substr(2, 9)}`;
        let recInfo = {}
        let url = ''
        const isVideo = (info.mediaType === FJConstant.VIDEO || info.videoUrl) ? true : false;
        let hasReadFile = false;
        const _jumpEditAppUrl = uploadKey => {
            const url = FJUtil.getCurrentUrl() + 'editor/app?rec_id=' + uploadKey;
            window.open(url);
        };
        if (FJAppConstant.FLEXCLIP_VIDEO_EDITOR === targetAppType) {
            let blobs = [];
            const medias = [{
                isVideo,
                url: info.videoUrl || info.imgUrl,
            }, ...(info?.originalImages || [info?.originalUrl]).map(item => ({
                isVideo: false,
                url: item,
            }))]
            for (const media of medias) {
                let blob;
                if (media.isVideo) {
                    blob = await FJUtil.downloadVideoCacheAvoidance(media.url);
                } else {
                    blob = await FJUtil.downloadImageCacheAvoidance(media.url);
                }
                if (blob) {
                    blob.name = FJUtil.getUseFileName('', media.isVideo ? '.mp4' : '.png');
                    blobs.push(blob);
                }
            }
            FJUtil.readFiles(
                blobs,
                {
                    module: 'media',
                    // isAddToPip: true,
                },
                _jumpEditAppUrl,
            );
            return;
        } else if (currentAppType === FJAppConstant.IMAGE_TO_VIDEO && (targetAppType === FJAppConstant.AI_PHOTO_EDITOR || targetAppType === FJAppConstant.TEXT_TO_IMAGE || targetAppType === FJAppConstant.IMAGE_TO_VIDEO)) {
            switch (targetAppType) {
                case FJAppConstant.AI_PHOTO_EDITOR:
                    recInfo = {
                        input_images: info?.originalImages?.map(item => (item + '?v=' + Date.now())),
                    };
                    break;
                case FJAppConstant.TEXT_TO_IMAGE:
                    recInfo = {
                        images: info?.originalImages?.map(item => (item + '?v=' + Date.now())),
                    };
                    break;
                case FJAppConstant.IMAGE_TO_VIDEO:
                    recInfo = {
                        images: info?.originalImages?.map(item => (item + '?v=' + Date.now())),
                    };
                    break;
            }
            url = FJUtil.getCurrentUrl() + href + '?rec_id=' + recId
            localStorage.setItem(recId, JSON.stringify(recInfo));
            window.open(url, '_blank');
            return;
        }
        switch (targetAppType) {
            case FJAppConstant.VIDEO_REMOVE_BG:
            case FJAppConstant.AI_VIDEO_DUB:
                // case FJAppConstant.AI_VIDEO_EFFECT:
                recInfo = {
                    avator: info.videoUrl + '?v=' + Date.now(),
                };
                hasReadFile = true;
                break;
            case FJAppConstant.AI_PHOTO_EDITOR:
                if (currentAppType === FJAppConstant.IMAGE_TO_VIDEO ||
                    currentAppType === FJAppConstant.AI_VIDEO_EFFECT
                ) {
                    recInfo = {
                        avator: (info?.originalImages[0] || info?.originalUrl || info?.imgUrl) + '?v=' + Date.now(),
                    };
                    hasReadFile = true;
                } else if (currentAppType !== FJAppConstant.TEXT_TO_VIDEO) {
                    recInfo = {
                        avator: info.imgUrl + '?v=' + Date.now(),
                    };
                    hasReadFile = true;
                }
                break;
            case FJAppConstant.IMAGE_TO_IMAGE:
            case FJAppConstant.PHOTO_REMOVE_BG:
            case FJAppConstant.OBJECT_ERASER:
                recInfo = {
                    avator: info.imgUrl + '?v=' + Date.now(),
                };
                hasReadFile = true;
                break;
            case FJAppConstant.IMAGE_TO_VIDEO:
                // case FJAppConstant.TEXT_TO_VIDEO:
                if (currentAppType !== FJAppConstant.TEXT_TO_VIDEO) {
                    recInfo = {
                        avator: info.imgUrl + '?v=' + Date.now(),
                    };
                    hasReadFile = true;
                }
                break;
            default:
                break;

        }
        if (hasReadFile) {
            url = FJUtil.getCurrentUrl() + href + '?rec_id=' + recId
            localStorage.setItem(recId, JSON.stringify(recInfo));
        } else {
            url = FJUtil.getCurrentUrl() + href
        }
        window.open(url, '_blank');
    },
};

export default FJCommunityUtil;
